import React, { useState, useEffect } from "react"
import Lib from "library"
import { TermsLayer, Button, LayerBottom } from "components"
import useApp from "hooks/useApp"

const CommonAgreeLayer = ({ allAgree = false, show, closeLayer, onAgree, agreeNow = true, termsCategoryCd, allCheck = true, buttonText = "동의", title, allText }) => {
	const App = useApp()
	const [terms, setTerms] = useState()
	const [termsToShow, setTermsToShow] = useState()
	const [showDetailLayer, setShowDetailLayer] = useState(false)
	const [disabled, setDisabled] = useState(true)
	const [allChecked, setAllChecked] = useState(allCheck)

	const showDetail = (termsCd) => {
		terms.forEach((item) => {
			if (item.termsCd === termsCd) {
				setTermsToShow(item)
			}
		})
	}

	useEffect(() => {
		if (termsToShow) setShowDetailLayer(true)
	}, [termsToShow])

	useEffect(() => {
		if (!showDetailLayer) {
			setTermsToShow()
		}
	}, [showDetailLayer])

	const onClickAll = (e) => {
		setTerms(
			terms.map((item) => {
				item.checked = !allChecked
				return item
			})
		)
	}

	const onClickCheck = (cd) => {
		setTerms(
			terms.map((item) => {
				if (item.termsCd === cd) {
					item.checked = !item.checked
				}
				return item
			})
		)
	}

	const onClick = () => {
		// 약관 동의 처리
		if (agreeNow) {

			// agreeNow 가 true일 경우에만 동의 API 호출(default: true)
			Lib.post(
				"/api/comm/terms/ins/agree",
				{
					termsAgreeList: terms.map((term) => {
						return {
							termsCd: term.termsCd,
							termsVer: term.termsVer,
						}
					}),
				},
				(data) => {
					if (onAgree) onAgree(terms)
				}
			)
		} else {
			// agreeNow 가 false 면 onAgree callback만 호출
			if (onAgree) onAgree(terms)
		}
	}

	useEffect(() => {
		if (!terms) return
		let ok = true,
			count = 0
		terms.forEach((item) => {
			if (item.termsNeedYn === "Y" && item.checked !== true) {
				ok = false
			}

			if (item.checked) count++
		})
		if (count === terms.length) {
			setAllChecked(true)
		} else {
			setAllChecked(false)
		}
		
		setDisabled(!ok)
	}, [terms])

	useEffect(() => {
		if (show) {
			Lib.get(
				"/api/comm/terms",
				{
					termsCtgryCd: termsCategoryCd,
				},
				(data) => {
					setTerms(
						data.map((item) => {
							item.checked = allChecked
							return item
						})
					)
				}
			)
		} else {
			setTerms()
			setDisabled(true)
		}
	}, [show])

	return (
		<LayerBottom
			title={title}
			show={show}
			closeLayer={closeLayer}
			outside={
				<div className='btn-group btn-group--inline button-group'>
					<Button className='btn btn--big btn-layer' onClick={onClick} disabled={disabled}>
						{buttonText}
					</Button>
				</div>
			}
		>
			<div>
				{terms ? (
					allAgree && (
						<div className='flex-justify_between pb_20'>
							<div>{allText ? allText : "전체동의"}</div>
							<i className={`checkMark ${allChecked ? "on" : ""}`} onClick={onClickAll} />
						</div>
					)
				) : (
					<div className='flex-justify_between pb_20' style={{ borderBottom: "1px solid silver" }}>
						<div className='skeleton' style={{ width: "10rem" }}></div>
						<i className='skeleton' style={{ width: "2rem" }} />
					</div>
				)}

				<ul style={{ fontSize: "1.4rem" }}>
					{terms ? (
						terms.map((item, index) => {
							return (
								<li key={index} className={index > 0 ? "mt_20" : undefined}>
									<div className='flex-align_center'>
										<i className={`mr_10 checkMark ${item.checked ? "on" : ""}`} onClick={() => onClickCheck(item.termsCd)} />
										<div onClick={() => showDetail(item.termsCd)}>
											{item.termsNeedYn === "Y" ? <span className='main-color'>[필수]</span> : <span>[선택]</span>}
											<span className='ml_5'>{item.termsNm}</span> <i className='icon_arrow_sm right ml_10' />
										</div>
									</div>
								</li>
							)
						})
					) : (
						<>
							<li className='flex-justify_between mt_20'>
								<div>
									<span className='skeleton mr_10' style={{ width: "3rem" }}></span>
									<span className='skeleton' style={{ width: "10rem" }}></span>
								</div>
								<i className='skeleton' style={{ width: "2rem" }} />
							</li>

							<li className='flex-justify_between mt_20'>
								<div>
									<span className='skeleton mr_10' style={{ width: "3rem" }}></span>
									<span className='skeleton' style={{ width: "10rem" }}></span>
								</div>
								<i className='skeleton' style={{ width: "2rem" }} />
							</li>
						</>
					)}
				</ul>
			</div>
			<TermsLayer
				show={showDetailLayer}
				closeLayer={() => setShowDetailLayer(false)}
				title={termsToShow?.termsNm}
				content={termsToShow?.termsConts}
				onButton={() => {
					setTerms(
						terms.map((item) => {
							if (item.termsCd === termsToShow?.termsCd) {
								item.checked = true
							}
							return item
						})
					)
					setShowDetailLayer(false)
				}}
			/>
		</LayerBottom>
	)
}

export default CommonAgreeLayer
